<template>
  <button
    class="button-toggle"
    :data-off="!isGuestMicMuted"
    @click="toggleAllowMic"
  >
    <ToggleSwitch
      :modelValue="isGuestMicMuted"
      @update:modelValue="toggleAllowMic"
    />
    {{ $t('force_mic') }}
  </button>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';

import ToggleSwitch from '@/components/shared/composite/ToggleSwitch.vue';
import { useCallStore } from '@/stores/call';
import { QRCodeType } from '@/stores/chat';
import { useSocketStore } from '@/stores/socket';

const socketStore = useSocketStore();
const callStore = useCallStore();
const { isGuestMicMuted } = storeToRefs(socketStore);

const toggleAllowMic = () => {
  if (QRCodeType.isGuest(callStore.qrCodeInfo.qrCodeType)) return false;

  socketStore.sendMessageMuteGuests(!socketStore.isGuestMicMuted);
};
</script>

<style scoped lang="scss"></style>

